import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { CHANGE_LOG_CATEGORY_LABELS } from "../../constants"

import { FilterCheckbox } from "@/components/common/Filters"
import { ChangeLogCategory } from "@/graphql/codegen/graphql"
import type { ChangeLogSearchFilters } from "@/screens/ChangeLog/stores/useChangeLogSearchStore"

const changeLogCategoryList = Object.values(ChangeLogCategory)

interface CategoryFilterProps {
  onFilterChange: (name: keyof ChangeLogSearchFilters, value: unknown) => void
}

const ChangeLogCategoryFilter: FC<CategoryFilterProps> = ({ onFilterChange }) => {
  const { control, watch } = useFormContext()
  const categoriesValue = watch("categories") || []

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      {changeLogCategoryList.map((changeLogCategory) => (
        <FilterCheckbox
          key={changeLogCategory}
          label={CHANGE_LOG_CATEGORY_LABELS[changeLogCategory]}
          value={changeLogCategory}
          control={control}
          name='categories'
          values={categoriesValue}
          onFilterChange={(values: string[]) => onFilterChange("categories", values)}
        />
      ))}
    </Box>
  )
}

export default ChangeLogCategoryFilter
